import Vue from 'vue';
import VueRouter from 'vue-router';

// 懒加载
const PcViews = () => import('views/PcViews')
const PcLogin = () => import('views/PcViews/Login')
const PcPasswordFind = () => import('views/PcViews/PasswordFind')
const PcLearn = () => import('views/PcViews/Learn')
const PcLearnCourse = () => import('views/PcViews/Learn/Course')
const PcLearnTrain = () => import('views/PcViews/Learn/Train')
const PcLearnTrainDetails = () => import('views/PcViews/Learn/Train/Details')
const PcLearnTrainNotice = () => import('views/PcViews/Learn/Train/Notice')
const PcLearnTrainNoticeDetails = () => import('views/PcViews/Learn/Train/Notice/Details')
const PcLearnUniversity = () => import('views/PcViews/Learn/University')
const PcLearnUniversityList = () => import('views/PcViews/Learn/University/List')
const PcLearnUniversityDetails = () => import('views/PcViews/Learn/University/Details')
const PcLearnClassroom = () => import('views/PcViews/Learn/Classroom')
const PcLearnClassroomList = () => import('views/PcViews/Learn/Classroom/List')
const PcLearnClassroomDetails = () => import('views/PcViews/Learn/Classroom/Details')
const PcInformation = () => import('views/PcViews/Information')
const PcInformationNoticeDetail = () => import('views/PcViews/Information/Details/Notice')
const PcInformationArticleDetail = () => import('views/PcViews/Information/Details/Article')
const PcOrderPayment = () => import('views/PcViews/Order/payment')
const PcOrderDetails = () => import('views/PcViews/Order/details')
const PcOrderResult = () => import('views/PcViews/Order/result')
const PcRegister = () => import('views/PcViews/Register')
const PcPersonal = () => import('views/PcViews/Personal')
const PcPersonalInformation = () => import('views/PcViews/Personal/ChildViews/information')
const PcPersonalOrder = () => import('views/PcViews/Personal/ChildViews/order')
const PcPersonalStudy = () => import('views/PcViews/Personal/ChildViews/study')
const PcPersonalCourse = () => import('views/PcViews/Personal/ChildViews/course')
const PcPersonalPhoto = () => import('views/PcViews/Personal/ChildViews/photo')
const PcPersonalCertificate = () => import('views/PcViews/Personal/ChildViews/certificate')
const PcPersonalPassword = () => import('views/PcViews/Personal/ChildViews/password')
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    {
        path: '/',
        redirect: '/pcViews/learn'
    },
    {
        path: '/pcViews',
        name: 'PcViews',
        component: PcViews,
        redirect: '/pcViews/learn',
        children: [
            //登录页
            {
                path: 'login',
                name: 'PcLogin',
                component: PcLogin
            },
            {
                path: 'password-find',
                name: 'PcPasswordFind',
                component: PcPasswordFind
            },
            //在线学习模块
            {
                path: 'learn',
                name: 'PcLearn',
                component: PcLearn,
                redirect: '/pcViews/learn/train',
                children: [
                    {
                        path: 'train',
                        name: 'PcLearnTrain',
                        component: PcLearnTrain
                    },
                    {
                        path: 'course',
                        name: 'PcLearnCourse',
                        component: PcLearnCourse
                    },
                    {
                        path: 'train-details',
                        name: 'PcLearnTrainDetails',
                        component: PcLearnTrainDetails
                    },

                    {
                        path: 'train-notice',
                        name: 'PcLearnTrainNotice',
                        component: PcLearnTrainNotice
                    },

                    {
                        path: 'train-notice-details',
                        name: 'PcLearnTrainNoticeDetails',
                        component: PcLearnTrainNoticeDetails
                    },

                    {
                        path: 'university',
                        name: 'PcLearnUniversity',
                        component: PcLearnUniversity
                    },
                    {
                        path: 'university-list',
                        name: 'PcLearnUniversityList',
                        component: PcLearnUniversityList
                    },
                    {
                        path: 'university-details',
                        name: 'PcLearnUniversityDetails',
                        component: PcLearnUniversityDetails
                    },
                    {
                        path: 'class-room',
                        name: 'PcLearnClassroom',
                        component: PcLearnClassroom
                    },
                    {
                        path: 'class-room-list',
                        name: 'PcLearnClassroomList',
                        component: PcLearnClassroomList
                    },
                    {
                        path: 'class-room-details',
                        name: 'PcLearnClassroomDetails',
                        component: PcLearnClassroomDetails
                    },
                ]
            },
            //信息模块
            {
                path: 'information',
                name: 'PcInformation',
                component: PcInformation
            },
            //信息模块--通知详情
            {
                path: 'information/notice-detail',
                name: 'PcInformationNoticeDetail',
                component: PcInformationNoticeDetail
            },
            //信息模块--行业新闻详情
            {
                path: 'information/article-detail',
                name: 'PcInformationArticleDetail',
                component: PcInformationArticleDetail
            },
            //订单支付
            {
                path: 'order-payment',
                name: 'PcOrderPayment',
                component: PcOrderPayment
            },
            //订单详情
            {
                path: 'order-details',
                name: 'PcOrderPayment',
                component: PcOrderDetails
            },
            //订单支付提示
            {
                path: 'order-result',
                name: 'PcOrderResult',
                component: PcOrderResult
            },
            //注册
            {
                path: 'register',
                name: 'PcRegister',
                component: PcRegister
            },
            //个人中心
            {
                path: 'personal',
                name: 'PcPersonal',
                component: PcPersonal,
                redirect: '/pcViews/personal/information',
                children: [
                    {
                        path: 'information',
                        name: 'PcPersonalInformation',
                        component: PcPersonalInformation
                    },
                    {
                        path: 'order',
                        name: 'PcPersonalOrder',
                        component: PcPersonalOrder
                    },
                    {
                        path: 'study',
                        name: 'PcPersonalStudy',
                        component: PcPersonalStudy
                    },
                    {
                        path: 'course',
                        name: 'PcPersonalCourse',
                        component: PcPersonalCourse
                    },
                    {
                        path: 'certificate',
                        name: 'PcPersonalCertificate',
                        component: PcPersonalCertificate
                    },
                    {
                        path: 'photo',
                        name: 'PcPersonalPhoto',
                        component: PcPersonalPhoto
                    },
                    {
                        path: 'password',
                        name: 'PcPersonalPassword',
                        component: PcPersonalPassword
                    },

                ]
            },
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
